<template lang="html">
	<vs-card class="shadow-none">
		<div
			class="vx-row flex flex-col sm:flex-row items-center justify-between"
			:class="{
				'flex-no-wrap': small
			}"
		>
			<div
				class="vx-col w-full sm:ml-6 flex"
				:class="{
					'sm:w-1/2 md:w-2/3 flex-col sm:flex-row md:m-auto': !small
				}"
				:style="{
					'width: calc(100% - 110px) !important': small
				}"
			>
				<div class="w-1/3 relative hidden sm:flex mr-4 md:m-auto">
					<img
						:src="getImageUrl(organization)"
						class="rounded-full shadow-md m-auto"
						:height="!small ? '70px' : '50px'"
						:width="!small ? '70px' : '50px'"
						style="object-fit: contain"
					/>
				</div>

				<div
					v-if="app"
					class="w-full md:ml-3"
					:class="small ? 'flex flex-col items-left' : 'text-center md:text-left'"
				>
					<h4 v-if="!small" class="title-sinao font-bold cursor-pointer">
						<a class="title-sinao cursor-pointer" :href="app.url">{{ organization?.name }}</a>
					</h4>

					<div
						v-if="app"
						:class="{
							'flex flex-col md:flex-row items-center md:items-start': small,
							'inline-block sm:mt-3': !small
						}"
					>
						<div :class="{ 'mt-3': !small }">
							<h4
								v-if="small"
								class="title-sinao font-bold cursor-pointer text-center sm:text-left mb-2 sm:mb-0"
							>
								<a class="title-sinao cursor-pointer" :href="app.url">{{ organization.name }}</a>
							</h4>

							<div
								v-if="user && app.admin_user_id == user.id && app.subscription"
								class="flex w-full mb-1 whitespace-no-wrap"
							>
								<p>{{ $t("Abonnement") }} :</p>
								<div class="relative ml-2">
									<vs-button
										v-if="
											app.subscription.plan.nickname == 'trial' ||
											app.subscription.plan.nickname == 'freemium'
										"
										class="detail text-xs"
										type="flat"
										style="padding: 1px 5px"
										icon-pack="feather"
										icon="icon-star"
										:disabled="disabled"
										@click="subscribtionClick(app.url)"
									>
										{{ $t("S’abonner") }}
									</vs-button>

									<vs-button
										v-else
										class="detail text-xs"
										type="flat"
										style="padding: 1px 5px"
										icon-pack="feather"
										icon="icon-star"
										:disabled="disabled"
										@click="subscribtionClick(app.url)"
									>
										{{ app.subscription.plan.nickname.toUpperCase() }}
									</vs-button>
								</div>
							</div>
							<div v-if="!small" class="hidden md:flex w-full whitespace-no-wrap">
								<p>
									{{ $t("N° SIREN") }} :
									<strong v-if="organization?.national_id">{{ organization?.national_id }}</strong>
									<strong v-else>{{ $t("Non renseigné") }}</strong>
								</p>

								<div class="relative ml-2">
									<vs-button
										class="detail text-xs"
										type="flat"
										style="padding: 1px 5px"
										icon-pack="feather"
										icon="icon-plus"
										:disabled="disabled"
										@click="switchDetails()"
									>
										{{ $t("Détails") }}
									</vs-button>
								</div>
								<div v-show="details" v-if="user && app.admin_user_id == user.id" class="relative ml-5">
									<vs-button
										class="detail text-xs"
										type="flat"
										style="padding: 1px 5px"
										icon-pack="feather"
										icon="icon-edit"
										:disabled="disabled"
										@click="adresseClick(app.url)"
									>
										{{ $t("Modifier") }}
									</vs-button>
								</div>
							</div>
							<div v-show="details && !small" class="text-left whitespace-no-wrap">
								<p>
									{{ $t("Code NAF") }} :
									<strong v-if="organization?.code_naf">{{ organization?.code_naf }}</strong>
									<strong v-else>{{ $t("Non renseigné") }}</strong>
								</p>
								<p>
									{{ $t("Adresse") }} :
									<strong>{{ organization?.headquarters?.place?.formatted_address }}</strong>
								</p>
							</div>

							<!-- dernier acces - NOT USED -->
							<!-- <div v-if="user && app.admin_user_id == user.id" class="text-left mt-1">
								<p v-if="dateToUTC(app.last_access)">
									{{ $t("Dernier accès le") }}
									{{ dateToUTC(app.last_access) }}
								</p>
							</div> -->

							<div v-if="!small" class="flex w-full text-left">
								<span v-if="planIsMonthly">
									{{
										$t("{plan_name} à {amount} € par mois.", {
											plan_name: subscriptionPlanName,
											amount: subscriptionPlanAmount
										})
									}}
								</span>
								<span v-else>
									{{
										$t("{plan_name} à {amount} € par an.", {
											plan_name: subscriptionPlanName,
											amount: subscriptionPlanAmount
										})
									}}
								</span>

								<!-- NOT USED -->
								<!-- <span v-if="hasUpcomingInvoice">
									, prochain prélèvement de 15,00€ le 14/03/2025. {{ $t("Prochain prélèvement de") }}
									{{ formatMoney(invoices.upcoming.amount_due / 100) }} € {{ $t("date de") }}
									{{ new Date(invoices.upcoming.created * 1000).toLocaleDateString("fr-FR") }}
								</span> -->
							</div>
						</div>

						<div
							class="vs-row flex"
							:class="{
								'w-fit justify-end items-center mr-5 md:ml-auto sm:mt-auto mb-3 sm:mb-auto': small,
								'w-full justify-center sm:justify-start mb-5 mt-2 m-auto': !small
							}"
						>
							<div class="flex">
								<img
									v-for="emp in policies.slice(0, 5)"
									:key="emp.id"
									:src="getImageUrl(emp.user)"
									width="44px"
									height="44px"
									class="avatar"
									:class="{ 'avatar-admin': hoverable && !disabled }"
								/>

								<vs-tooltip
									v-if="
										(!app.subscription.plan.limits.users ||
											app.policies.length + app.invites.length <
												app.subscription.plan.limits.users) &&
										!app.subscription.plan.rights.includes('!app.policies.invitations')
									"
									class="tooltip"
									:text="$t('Ajouter un utilisateur')"
								>
									<router-link
										v-if="user && app.admin_user_id == user.id"
										tag="button"
										class="btn-admin"
										:to="{ name: 'Invite', params: { appId: app.id } }"
										:tearia-labelxt="$t('Ajouter un utilisateur')"
										:disabled="disabled"
									>
										<vs-icon icon-pack="feather" icon="icon-user-plus" />
									</router-link>
								</vs-tooltip>

								<vs-tooltip class="tooltip" :text="$t('Gérer les utilisateurs')">
									<button
										v-if="
											user &&
											app.admin_user_id == user.id &&
											!app.subscription.plan.rights.includes('!app.policies.invitations')
										"
										class="btn-admin"
										:aria-label="$t('Gérer les utilisateurs')"
										:disabled="disabled"
										@click="membersClick()"
									>
										<vs-icon icon-pack="feather" icon="icon-settings" />
									</button>
								</vs-tooltip>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="w-fit flex text-center sm:mr-10">
				<div class="flex items-center" :class="{ 'sm:mr-0': !small }">
					<s-button
						class="m-auto"
						icon="icon-arrow-right"
						icon-after="true"
						:disabled="disabled"
						@click="redirectTo(app.url)"
					>
						<span :class="{ 'sm:hidden': small }"> {{ $t("Tableau de bord") }} </span>
					</s-button>
				</div>
			</div>
		</div>
	</vs-card>
</template>

<script lang="js">
	// pour créer une date UTC europe
	var moment = require('moment-timezone');

	import { mapState, mapGetters } from "vuex";

	export default {
		name: 'OrganizationItem',
		props: {
			app: Object,
			disabled: Boolean,
			small: { type: Boolean, default: false },
		},
		data() {
			return {
				details: false,
				organization: null,
				policies: null,
				invites: null
			};
		},
		computed: {
			...mapState(["user"]),
			...mapGetters(["getImageUrl"]),
			hoverable() {
				return this.app.admin_user_id == this.user?.id;
			},
			subscription() {
				return this.app.subscription;
			},
			hasUpcomingInvoice() {
				return !!this.app?.subscription?.invoices?.upcoming;
			},
			subscriptionPlanName() {
				return this.capitalizeFirstLetter(
					this.app?.subscription?.plan?.metadata?.name || this.app?.subscription?.plan?.nickname || ''
				);
			},
			subscriptionPlanAmount() {
				if ((this.constainsPaymentManager && !this.isPaymentManager) || this.app.subscription.plan.rights.includes('!app.subscription')) return this.formatMoney(0);
				return this.formatMoney(this.app?.subscription?.plan?.unit_amount / 100);
			},
			planIsMonthly() {
				return this.app?.subscription?.plan?.interval === 'month';
			},
			isPaymentManager() {
				return this.app.policies.some(policy => policy.policy_profile_id === 14 && policy.user_id === this.user?.id);
			},
			constainsPaymentManager() {
				return this.app.policies.filter(policy => policy.policy_profile_id == 14).length > 0;
			}
		},
		created() {
			const { organization, policies, invites, admin } = this.app;

			this.organization = organization;
			this.policies = policies.reduce((acc, cur) => {
				if (
					acc.findIndex(policy => policy.user_id === cur.user_id) === -1 &&
					cur.user_id !== admin.id
				) {
					acc.push(cur);
				}
				return acc;
			}, []);
			this.invites = invites;

			this.policies.push({
				user_id: admin.id,
				policy_profile_id: 6,
				app_id: this.appId,
				user: admin
			});
		},
		methods: {
			// retourne un string du dernier accès à l'app (de la forme "xx/xx/xxxx à xxhxx" timeZone : Europe)
			dateToUTC: function(date) {
				if (date != null) {
					// si on a une date, on la met au format UTC+1
					var newDate = moment.tz(date, 'Europe/Berlin').format();

					// on découpe pour afficher sous la forme : XX/XX/XXXX à XXhXX
					return `${ newDate.substr(8, 2) }/${ newDate.substr(5, 2) }/${ newDate.substr(0, 4) } à ${ newDate.substr(11, 5) }`;
				}
				else {
					// on retourne false, ce qui annulera l'affichage de la date grâce au v-if de la balise <p>
					return false;
				}
			},
			// permet d'afficher les détails (adresse, codeNaf) pour l'entreprise voulue
			switchDetails: function() {
				this.details = !this.details;
			},
			membersClick() {
				if (this.app.admin_user_id == this.user?.id && !this.disabled) {
					this.$router.push({ path: `/${this.app.id}/members`, query: this.$route.query });
				}
			},
			// permet la redirection vers les abonnements du compte de l’utilisateur
			subscribtionClick: function(path) {
				if(this.constainsPaymentManager || this.app.subscription.plan.rights.includes('!app.subscription')) return;
				window.location.href = `${ path }settings/subscription/select/`;
			},
			// permet la redirection vers le formulaire de mise a jour des information de l'entreprise selectionnée
			adresseClick(path) {
				window.location.href = `${ path }settings/organization/`;
			},
			// permet la redirection vers l'app principale/tableau de bord
			redirectTo: function(lien) {
				window.location.href = lien;
			},
			capitalizeFirstLetter: function(string) {
				return string[0].toUpperCase() + string.slice(1);
			},
			formatMoney: function(number, decimalMin = 2, decimalMax = 2) {
				if (typeof number === 'string')
					number = number.replace(/,/g, ".").replace(/\s/g, "");

				let numericValue = parseFloat(number);
				if (isNaN(numericValue))
					numericValue = 0;

				return new Intl.NumberFormat("fr-FR", {
					minimumFractionDigits: decimalMin ?? 2,
					maximumFractionDigits: decimalMax ?? 2,
				}).format(numericValue)
			}
		}
	};
</script>

<style scoped lang="scss">
	.avatar-admin:hover,
	.btn-admin:hover,
	.avatar-admin:focus,
	.btn-admin:focus {
		transform: translateY(-5px);
	}
	.tooltip {
		padding-right: 15px;
		margin-right: -15px;
		border-radius: 50%;
	}
</style>
